/**************************************************
 * Nombre:       Home_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Anuncio from "../../Tarjetas/Tarjeta_Anuncio";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Anuncios = () => {
    const {sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start'}}>


                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: sTab ? 2 : 1,
                            arrows: true,
                            pagination: true,
                            width: '100%',
                            drag: 'false',
                            interval: 5000,
                            noDrag: true,
                            gap: 20

                        }}
                    >

                        {items.map((srcImg, index) => {
                            return (
                                <SplideSlide key={`qe${index}`}>
                                    <Tarjeta_Anuncio/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>




                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Anuncios

const items = [1, 2, 3]